import React, { useCallback } from 'react';
import classnames from 'classnames';
import BillingInputComponent from '../../template-blocks/billing-input/billing-input-component';
import EditableInput from '../../template-blocks/editable-input/editable-input';

import './billing-component.scss';

const EMPTY_TITLE = '';

export default function BillingComponent({
  billFrom,
  billTo,
  boardSelectOptions,
  id,
  onTemplateDataChange,
  data,
  previewMode,
}) {
  const onBillingInputChange = useCallback(
    (inputId, inputData) => {
      onTemplateDataChange(id, { ...data, [inputId]: inputData });
    },
    [id, onTemplateDataChange, data]
  );

  const onSectionTitleChange = (sectionId, newTitle) => {
    const updatedTitle = {
      [sectionId]: { title: newTitle },
    };

    onTemplateDataChange(id, { ...data, ...updatedTitle });
  };

  const renderFields = (fields) => {
    return fields.map(({ id: fieldId, type, title, placeholder, inputProps }) => {
      return (
        <div key={fieldId} className="billing-input-component-wrapper pdf-row">
          <BillingInputComponent
            id={fieldId}
            title={title}
            withTitle={true}
            type={type}
            previewMode={previewMode}
            placeholder={placeholder}
            inputProps={inputProps}
            onChange={onBillingInputChange}
            boardSelectOptions={boardSelectOptions}
            value={data[fieldId]?.data || ''}
          />
        </div>
      );
    });
  };

  const renderSection = ({ id: sectionId, title, subtitle, fields, className }) => {
    let titleText = title;
    const updatedTitle = data[sectionId]?.title;

    if (updatedTitle || updatedTitle === EMPTY_TITLE) {
      titleText = updatedTitle;
    }

    let titleContent = <>{titleText}</>;

    if (!previewMode) {
      titleContent = (
        <EditableInput
          value={titleText}
          className="try"
          onBlur={(newTitle) => onSectionTitleChange(sectionId, newTitle)}
        />
      );
    }

    return (
      <div className={classnames('bill-section', className)}>
        <span className="bill-section-title pdf-row">{titleContent}</span>
        {!previewMode && <span className="bill-section-subtitle">{subtitle}</span>}
        {renderFields(fields)}
      </div>
    );
  };

  return (
    <div className={classnames('billing-component', { preview: previewMode })}>
      {renderSection({ ...billFrom, className: 'bill-from' })}
      {renderSection({ ...billTo, className: 'bill-to' })}
    </div>
  );
}
